module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjE4OSIgdmlld0JveD0iMCAwIDMwMSAxODkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjNEFBREQ2IiBkPSJNLjUuNzVoMzAwdjE4Ny41SC41eiIvPjxjaXJjbGUgZmlsbD0iI0ZGREUwMCIgY3g9IjEzMS43NSIgY3k9Ijk0LjUiIHI9IjU2LjI1Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-pw.svg
// module id = 86Y5
// module chunks = 2